import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { NfcCard, Query } from 'graphql/generated/graphqlTypes';
import {
  mockVisitor10KeySharing,
  mockVisitor12WithBlockedCard,
  mockVisitor3WithGroups,
  mockVisitor4,
  mockVisitor6,
  mockVisitor8ExpiringTomorrow,
  mockVisitor9Expired,
  mockVisitorCleaner,
  mockVisitorInstaller
} from 'mocks/graphqlMocks/visitorFixtures';

dayjs.extend(utc);

export function mockedGetAccessCardsData(getNfcCards: NfcCard[]): Pick<Query, 'getNfcCards'> {
  return {
    getNfcCards
  };
}

export const mockedGetAccessCardsDataForQuery = mockedGetAccessCardsData([
  {
    name: '#0000000001',
    uuid: '#0000000001',
    updateRequired: false,
    __typename: 'NfcCard',
    assignment: {
      expiryDate: dayjs().utc().subtract(1, 'day').toISOString(),
      blocked: null,
      expired: true,
      visitor: mockVisitorInstaller,
      visitorName: mockVisitorInstaller.name
    }
  },
  {
    name: '#0000000002',
    uuid: '#0000000002',
    updateRequired: false,
    __typename: 'NfcCard',
    assignment: {
      expiryDate: dayjs().utc().add(1, 'year').toISOString(),
      blocked: { since: dayjs().utc().subtract(1, 'week').toISOString(), reason: 'Lost card' },
      expired: false,
      visitor: mockVisitorCleaner,
      visitorName: mockVisitorCleaner.name
    }
  },
  {
    name: '#0000000003',
    uuid: '#0000000003',
    updateRequired: false,
    __typename: 'NfcCard',
    assignment: {
      expiryDate: dayjs().utc().add(1, 'day').toISOString(),
      blocked: null,
      expired: false,
      visitor: mockVisitor3WithGroups,
      visitorName: mockVisitor3WithGroups.name
    }
  },
  {
    name: '#0000000004',
    uuid: '#0000000004',
    updateRequired: false,
    __typename: 'NfcCard',
    assignment: {
      expiryDate: dayjs().utc().add(3, 'day').toISOString(),
      blocked: null,
      expired: false,
      visitor: mockVisitor4,
      visitorName: mockVisitor4.name
    }
  },
  {
    name: '#0000000005',
    uuid: '#0000000005',
    updateRequired: false,
    __typename: 'NfcCard',
    assignment: {
      expiryDate: dayjs().utc().add(1, 'week').toISOString(),
      blocked: null,
      expired: false,
      visitor: null,
      visitorName: 'Larissa ter Haar'
    }
  },
  {
    name: '#0000000006',
    uuid: '#0000000006',
    updateRequired: false,
    __typename: 'NfcCard',
    assignment: {
      expiryDate: dayjs().utc().add(4, 'week').toISOString(),
      blocked: null,
      expired: false,
      visitor: mockVisitor6,
      visitorName: mockVisitor6.name
    }
  },
  {
    name: '#0000000008',
    uuid: '#0000000008',
    updateRequired: true,
    __typename: 'NfcCard',
    assignment: {
      expiryDate: dayjs().utc().add(2, 'month').toISOString(),
      blocked: null,
      expired: false,
      visitor: mockVisitor8ExpiringTomorrow,
      visitorName: mockVisitor8ExpiringTomorrow.name
    }
  },
  {
    name: '#0000000009',
    uuid: '#0000000009',
    updateRequired: false,
    __typename: 'NfcCard',
    assignment: {
      expiryDate: dayjs().utc().add(3, 'month').toISOString(),
      blocked: null,
      expired: false,
      visitor: mockVisitor9Expired,
      visitorName: mockVisitor9Expired.name
    }
  },
  {
    name: '#0000000010',
    uuid: '#0000000010',
    updateRequired: false,
    __typename: 'NfcCard',
    assignment: {
      expiryDate: dayjs().utc().add(4, 'month').toISOString(),
      blocked: null,
      expired: false,
      visitor: mockVisitor10KeySharing,
      visitorName: mockVisitor10KeySharing.name
    }
  },
  {
    name: '#0000000011',
    uuid: '#0000000011',
    updateRequired: false,
    __typename: 'NfcCard',
    assignment: null
  },
  {
    name: '#0000000012',
    uuid: '#0000000012',
    updateRequired: false,
    __typename: 'NfcCard',
    assignment: {
      expiryDate: dayjs().utc().add(5, 'month').toISOString(),
      blocked: null,
      expired: false,
      visitor: mockVisitor12WithBlockedCard,
      visitorName: mockVisitor12WithBlockedCard.name
    }
  }
]);
